import { capitalizeFirstLetter } from '../patients/utils'

import { allocation } from '../bedManagement/modals'
import {
  FREQUENCY_TYPES,
  MEAL_INTERVALS,
  MEAL_TIMINGS,
  MEALS,
} from './constant'
import { MealProgress } from '../bedManagement/IpdVisit/IpdSummary/MedicationProgress'
interface option {
  value: string
  name: string
}

const OpdMedicationDashboard = ({ allMedications }: any) => {
  return (
    <div className='opd-medication-dashboard opd-medication-container'>
      <table className='data-table admin-table medication-relative'>
        <thead className='sticky medication-table-head-content'>
          <tr>
            <th className='table-w-4'>Sl&nbsp;No</th>
            <th className='text-left w14'>Drug Name</th>
            <th className='text-center w4'>Dose</th>
            <th className='text-center w8'>Unit</th>
            <th className='text-center w10'>Route</th>
            <th className='text-center w9'>Frequency</th>
            <th className='text-center w22'>Intervals</th>
            <th className='text-center w10'>Duration/Units</th>
            <th className='text-center w8'>Total.Qty</th>
            <th className='text-center w9'>Start Date</th>
            <th className='text-center w9'>End Date</th>
          </tr>
        </thead>
        <tbody>
          {allMedications?.length === 0 ? (
            <tr>
              <td colSpan={9} className='text-center'>
                {allocation.noMedications}
              </td>
            </tr>
          ) : (
            allMedications?.map((medication: any, index: any) => (
              <tr key={index}>
                <td className='text-center'>{index + 1}</td>
                <td>{capitalizeFirstLetter(medication?.drug_name)}</td>
                <td className='text-center'>{medication?.dose}</td>
                <td className='text-center'>
                  {capitalizeFirstLetter(medication?.dose_units)}
                </td>
                <td className='text-center'>
                  {capitalizeFirstLetter(medication?.route)}
                </td>
                <td className='text-center'>
                  {capitalizeFirstLetter(medication?.frequency)}
                </td>
                <td>
                  {medication?.intervals?.length > 0 ? (
                    <div className='drug-flexRow'>
                      {(medication?.frequency === FREQUENCY_TYPES?.IMMEDIATE ||
                        medication?.frequency === FREQUENCY_TYPES?.ONCE_DAY ||
                        medication?.frequency === FREQUENCY_TYPES?.TWICE_DAY ||
                        medication?.frequency === FREQUENCY_TYPES?.FIVE_DAY ||
                        medication.frequency === FREQUENCY_TYPES?.THRICE_DAY ||
                        medication.frequency === FREQUENCY_TYPES?.FOUR_DAY) && (
                        <MealProgress
                          activeMeals={[
                            {
                              meal: MEALS?.BREAKFAST,
                              time: medication?.intervals?.some(
                                (o: option) =>
                                  o?.value === MEAL_INTERVALS?.BREAKFAST_BEFORE
                              )
                                ? MEAL_TIMINGS?.BEFORE
                                : '',
                            },
                            {
                              meal: MEALS?.BREAKFAST,
                              time: medication?.intervals?.some(
                                (o: option) =>
                                  o?.value === MEAL_INTERVALS?.BREAKFAST_AFTER
                              )
                                ? MEAL_TIMINGS?.AFTER
                                : '',
                            },
                            {
                              meal: MEALS?.LUNCH,
                              time: medication.intervals?.some(
                                (o: option) =>
                                  o?.value === MEAL_INTERVALS?.LUNCH_BEFORE
                              )
                                ? MEAL_TIMINGS?.BEFORE
                                : '',
                            },
                            {
                              meal: MEALS?.LUNCH,
                              time: medication?.intervals?.some(
                                (o: option) =>
                                  o?.value === MEAL_INTERVALS?.LUNCH_AFTER
                              )
                                ? MEAL_TIMINGS?.AFTER
                                : '',
                            },
                            {
                              meal: MEALS?.DINNER,
                              time: medication?.intervals?.some(
                                (o: option) =>
                                  o?.value === MEAL_INTERVALS?.DINNER_BEFORE
                              )
                                ? MEAL_TIMINGS?.BEFORE
                                : '',
                            },
                            {
                              meal: MEALS?.DINNER,
                              time: medication?.intervals?.some(
                                (o: option) =>
                                  o?.value === MEAL_INTERVALS?.DINNER_AFTER
                              )
                                ? MEAL_TIMINGS?.AFTER
                                : '',
                            },
                          ]}
                        />
                      )}
                      {medication?.frequency == FREQUENCY_TYPES?.HOUR &&
                        medication?.intervals?.[0]?.value}
                      {medication?.frequency ==
                        FREQUENCY_TYPES?.EVERY_TWO_WEEKS &&
                        medication?.intervals?.[0]?.value}
                      {medication?.frequency ==
                        FREQUENCY_TYPES?.EVERY_THREE_WEEKS &&
                        medication?.intervals?.[0]?.value}
                      {medication?.frequency == FREQUENCY_TYPES?.DAY ||
                        medication?.frequency == FREQUENCY_TYPES?.WEEK ||
                        (medication?.frequency == FREQUENCY_TYPES?.MONTH &&
                          medication?.intervals?.[0]?.value)}
                    </div>
                  ) : (
                    '-'
                  )}
                </td>
                <td className='text-center'>
                  {medication?.duration} {medication?.duration_units}
                </td>
                <td className='text-center'>{medication?.total_quantity}</td>
                <td className='text-center'>{medication?.start_date}</td>
                <td className='text-center'>
                  {medication?.next_visit_date ?? '-'}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}
export default OpdMedicationDashboard
